import React, { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import FolderOpen from "../../../assets/folder-open.svg";
import { VisibilityOff } from "@material-ui/icons";

export const NoTeamCodeFilterView: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.main}>
      <section className={classes.container}>
        <VisibilityOff className={classes.eyeIcon}/>
        <Box className={classes.textContainer}>
          <Typography className={classes.title}>Team Codes Hidden</Typography>
          <Typography className={classes.description}>
            Enable <b>Show My Team Codes</b> to see all companies
          </Typography>
        </Box>
      </section>
    </Box>
  );
};

export const EmptyCompanyView: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.main}>
      <section className={classes.container}>
        <img src={FolderOpen} alt="No Data" className={classes.icon} />
        <Box className={classes.textContainer}>
          <Typography className={classes.title}>Portfolio Not Setup</Typography>
          <Typography className={classes.description}>
            To set up your portfolio, you can add individual companies from the <b>All Companies</b> or{" "}
            <b>Watchlist </b>tabs, or add multiple companies at once by selecting <b>Team Codes</b> above.
          </Typography>
        </Box>
      </section>
    </Box>
  );
};
